import * as React from 'react'
import { ReactElement, useMemo } from 'react'
import ComposeOutlookItemDialogBody, { ComposeOutlookItemDialogBodyProps } from './ComposeOutlookItemDialogBody'
import { HammockDialogProps } from '../HammockDialog'
import {  outlookDisplayNewAppointmentForm } from '../../../../helpers/outlookHelper'
import { ComposeEmailDialogBodyProps } from './ComposeEmailDialogBody'
import AsyncResultStatus = Office.AsyncResultStatus
import EmailAddressDetails = Office.EmailAddressDetails

export type ComposeAppointmentDialogBodyProps = Pick<ComposeOutlookItemDialogBodyProps, 'file' | 'parties' | 'callback'>

type BodyProps = ComposeAppointmentDialogBodyProps & ComposeOutlookItemDialogBodyProps

export default function ComposeAppointmentDialogBody(props: HammockDialogProps<ComposeAppointmentDialogBodyProps>): ReactElement {
    const dialogBodyProps = useMemo(() => props.dialogBodyProps?.() ?? ({} as ComposeEmailDialogBodyProps), [props])

    return (
        <ComposeOutlookItemDialogBody<BodyProps>
            {...(props as HammockDialogProps<BodyProps>)}
            dialogBodyProps={() =>
                ({
                    ...dialogBodyProps,
                    titleKey: 'action.create.appointment',
                    descriptionKey: 'action.create.appointment.description',
                    submitButtonTextKey: 'action.appointment.email',
                    onCompose: async (requiredAttendees: EmailAddressDetails[], subject: string) => {
                        outlookDisplayNewAppointmentForm({ requiredAttendees, subject }, (asyncResult?: Office.AsyncResult<void>) => {
                            if (!asyncResult || asyncResult?.status === AsyncResultStatus.Succeeded) {
                                dialogBodyProps.callback?.()
                                props.onDismiss()
                            }
                        })
                        return Promise.resolve()
                    },
                }) as BodyProps
            }
        />
    )
}
